import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from '@ant-design/compatible';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import EventSaveWrap from './EventSaveWrap';
import useEventDetailInitialValue from './hooks/useEventDetailInitialValue';
import useSubmit from './hooks/useSubmit';
import useEventPreview from './hooks/useEventPreview';
import usePrompt from '../../../hooks/common/usePrompt';
import {
  EVENT_SAVE_INFO_TAB_INDEX,
  EVENT_SAVE_INITIAL_VALUE,
  EVENT_SAVE_RESULT,
  EVENT_SECTION_TAB_INDEX,
} from '../../../constants/service/app/eventConstants';
import { ValueOf } from '../../../types/common/utils';

function EventSaveContainer(props: FormComponentProps) {
  const { form } = props;
  const [eventSaveInfoTabKey, setEventSaveInfoTabKey] = useState(EVENT_SAVE_INFO_TAB_INDEX);
  const [eventSectionTabKey, setEventSectionTabKey] = useState<number | null>(EVENT_SECTION_TAB_INDEX);
  const [eventSaveResult, setEventSaveResult] = useState<ValueOf<typeof EVENT_SAVE_RESULT>>(EVENT_SAVE_RESULT.NONE);
  const { id } = useParams<{ id?: string }>();
  const { data } = useEventDetailInitialValue({ form, id: Number(id), setEventSectionTabKey });
  const { onSubmit, isSubmitting } = useSubmit({ form, id, setEventSectionTabKey, setEventSaveResult });
  const { preview } = useEventPreview({ form });

  usePrompt(eventSaveResult !== EVENT_SAVE_RESULT.SUCCESS && !isSubmitting, '편집을 중단하시겠습니까?');

  return (
    <EventSaveWrap
      form={form}
      eventSave={data ?? EVENT_SAVE_INITIAL_VALUE}
      onSubmit={onSubmit}
      preview={preview}
      eventSaveInfoTabKey={eventSaveInfoTabKey}
      setEventSaveInfoTabKey={setEventSaveInfoTabKey}
      eventSectionTabKey={eventSectionTabKey}
      setEventSectionTabKey={setEventSectionTabKey}
    />
  );
}

export default Form.create()(EventSaveContainer);
